// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__1iRxz","footer_span":"footer_footer_span__3E9Ni"};